<nav class="navbar navbar-default navbar-fixed-top">
  <div class="navdiv">
    <div class="navbar-header navhead">
      <a class="navbar-brand" (click)="goToHome($event)">
        <img class="finzy-icon"
        src="https://res.cloudinary.com/finzy/image/upload/v1702367764/finzy_logo_full_ca8aib.svg"
        alt="finzy logo - Home"></a>

      <div class="d-inline-flex align-items-center" *ngIf="secondaryLogoUrl">
        <div class="brand-separator mt-1 ml-3 mr-2"></div>
        <img [src]="secondaryLogoUrl" class="secondary-logo ml-2">
      </div>

      <span class="brand-suffix pull-left" [routerLink]="['/articles/finzy-gets-nbfc-p2p-certificate']" *ngIf="!secondaryLogoUrl">
        <img src="../../assets/images/badge_small.png" id="badge-small-image">
        <span style="display:inline-block">
          <span id="brand-suffix-header">NBFC-P2P</span>
          <br/>
          <span id="brand-suffix-sub">Registered with RBI</span>
        </span>
      </span>

      <button *ngIf="!autoSignIn" type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#dropdownmenu"
              aria-expanded="false">
        <i class="material-icons navcolor">menu</i>
      </button>
    </div>

    <div class="collapse navbar-collapse" id="dropdownmenu" *ngIf="!autoSignIn">
      <ul class="nav navbar-nav navbar-right">

        <li [ngStyle]="{ 'opacity': 1,'cursor':'pointer' }" [ngClass]="{active: isMenuItemSelected(borrowerMenuItem)}">
          <a (click)="onMenuItemClick(borrowerMenuItem)">
            <p class="navoptions">{{borrowerMenuItem}}</p>
          </a>
        </li>

        <li *ngIf="!isLenderVerified" [ngStyle]="{ 'opacity': 1,'cursor':'pointer' }"
            [ngClass]="{active: isMenuItemSelected(investorMenuItem)}">
          <a (click)="onMenuItemClick(investorMenuItem)">
            <p class="navoptions">{{investorMenuItem}}</p>
          </a>
        </li>

      
        <li *ngIf="isLenderVerified" class="onlyDesktop">
          <a class="dropdown-toggle loggedHover" data-toggle="dropdown">{{activeProductName}} <span class="caret"></span></a>
          <ul class="dropdown-menu">
            <li *ngFor="let product of masterProductWithLink">
              <a class="subMenu" [routerLink]="isFINXUser(product.name) ? [] : [product.link]" [ngClass]="{cursor_not_allowed: isFINXUser(product.name)}">
                <img class="profile-pic dropdown-menu-icon" src="./../../assets/images/finzy-flex/dashboard-inactive.svg" />
                <span>
                  {{product.name}}
                </span>
              </a>
            </li>
          </ul>
        </li>
        
        <ng-template [ngIf]="isLenderVerified">
          <ng-template ngFor let-product [ngForOf]="masterProductWithLink">
            <li *ngIf="isLender" class="onlyMobile">
              <a class="mobilePointer" [routerLink]="[product.link]">
                <p class="navoptions">{{product.name}}</p>
              </a>
            </li>
          </ng-template>
        </ng-template>

        <li *ngIf="!loggedIn" routerLinkActive="active">
          <a href="javascript:void(0);"  (click)="onMenuItemClick(loginMenuItem)">
            <p class=" navoptions">LOGIN</p>
          </a>
        </li>

        <li *ngIf="loggedIn" class="onlyDesktop">

          <a class="dropdown-toggle loggedHover name" data-toggle="dropdown">{{name}} <span class="caret"></span></a>
          <ul class="dropdown-menu">
            <li>
              <a class="subMenu" [routerLink]="['/profile']">
                <img class="profile-pic dropdown-menu-icon" src="./../../assets/images/profile.svg"/>
                <span>
                  Profile
                </span>
              </a>
            </li>
            <li *ngIf = "isLender">
              <a class="subMenu" [routerLink]="['/nominee']">
                <img class="profile-pic dropdown-menu-icon" src="./../../assets/images/nominee/nominee-icon.svg"/>
                <span>
                  Nominee
                </span>
              </a>
            </li>
            <li *ngIf="!(hasRPC)">
              <a class="subMenu" [routerLink]="['/referrals']">
                <img class="profile-pic dropdown-menu-icon" src="./../../assets/images/refer.svg"/>
                <span>
                  Refer & Earn
                </span>
              </a>
            </li>
            <li><a class="subMenu" (click)="logout()"><i class="fa fa-power-off fontaws dropdown-menu-icon"
                                                         aria-hidden="true"></i>&nbsp;
              Logout</a></li>
          </ul>
        </li>

        <li class="onlyMobile"><a class="mobilePointer" [routerLink]="['/profile']">
          <p class="navoptions">PROFILE</p></a>
        </li>

          <li *ngIf="isLender" class="onlyMobile"><a class="mobilePointer" [routerLink]="['/nominee']">
              <p class="navoptions">NOMINEE</p></a>
          </li>

        <li *ngIf="!hasRPC" class="onlyMobile"><a class="mobilePointer" [routerLink]="['/referrals']">
          <p class="navoptions">REFER & EARN</p></a>
        </li>

        <li *ngIf="loggedIn" class="onlyMobile"><a class="mobilePointer" (click)="logout()">
          <p class="navoptions">LOGOUT</p></a>
        </li>

        <li><a [routerLink]="['/borrow/intro']" *ngIf="shouldShowApplyNowButton"
               (click)="analyticsTracker.trackButtonClick('Borrower Home' , 'Apply Now',  'Header'); tracker.trackButtonClick();">
          <p class="navoptions2">APPLY NOW</p></a>
        </li>

        <li><a [routerLink]="['/lenderintro']" *ngIf="shouldShowInvestNowButton"
               (click)="analyticsTracker.trackButtonClick('Investor home/Campaign','Invest Now', 'Header')">
          <p class="navoptions2">INVEST NOW</p></a>
        </li>

      </ul>
    </div>
  </div>
</nav>
